'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Home, RotateCcw, AlertTriangle } from 'lucide-react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="container mx-auto px-4 py-16 max-w-2xl text-center">
      <div className="mb-8">
        <AlertTriangle className="h-16 w-16 text-destructive/40 mx-auto" />
      </div>

      <h1 className="font-heading text-3xl font-bold mb-3">Något gick fel</h1>
      <p className="text-muted-foreground mb-8 text-lg">
        Ett oväntat fel uppstod. Försök igen eller gå tillbaka till startsidan.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <button
          onClick={reset}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
        >
          <RotateCcw className="h-4 w-4" />
          Försök igen
        </button>
        <Link
          href="/"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 border rounded-lg font-medium hover:bg-muted transition-colors"
        >
          <Home className="h-4 w-4" />
          Till startsidan
        </Link>
      </div>

      <p className="text-sm text-muted-foreground mt-8">
        Kvarstår problemet? Kontakta oss på{' '}
        <a href="tel:042201620" className="text-primary hover:underline font-medium">042-20 16 20</a>
        {' '}eller{' '}
        <a href="mailto:info@autofrance.se" className="text-primary hover:underline font-medium">info@autofrance.se</a>
        {error?.digest && <span className="block mt-1 text-xs text-muted-foreground/60">Felkod: {error.digest}</span>}
      </p>
    </div>
  );
}
